export default __webpack_public_path__ + "static/media/6.8228491c.svg";